import React from 'react';
import { useHistory } from 'react-router-dom';

/**
 * The Udupi Head Branch  |  Shimoga switch at the top of every login card.
 *
 * Replaces the second "Shimoga Login" dropdown that used to sit next to
 * "Login As" on the home page. It only navigates between the two login pages;
 * the Shimoga section (src/shimoga) stays a completely separate portal with
 * its own storage.
 *
 *   type    'Customer' | 'Company' - which login pair to switch between
 *   active  'main' | 'shimoga'     - the page this is shown on
 */
const BranchSwitch = ({ type = 'Customer', active = 'main' }) => {
    const history = useHistory();
    const go = (to) => history.push(to);

    const options = [
        { key: 'main', label: 'Udupi Head Branch', to: '/' + type },
        { key: 'shimoga', label: 'Shimoga', to: '/Shimoga/' + type },
    ];

    return (
        <div className='branchSwitch' role='tablist' aria-label='Choose branch'>
            {options.map((o) => (
                <button
                    key={o.key}
                    type='button'
                    role='tab'
                    aria-selected={active === o.key}
                    className={'branchSwitchBtn' + (active === o.key ? ' branchSwitchOn' : '')}
                    onClick={() => active !== o.key && go(o.to)}
                >
                    {o.label}
                </button>
            ))}
        </div>
    );
};

export default BranchSwitch;
